import { render, staticRenderFns } from "./foodCategories.vue?vue&type=template&id=8ed62ab0&scoped=true&"
import script from "./foodCategories.vue?vue&type=script&lang=js&"
export * from "./foodCategories.vue?vue&type=script&lang=js&"
import style0 from "./foodCategories.vue?vue&type=style&index=0&id=8ed62ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed62ab0",
  null
  
)

export default component.exports